import React from 'react'
import { useGenericRequestHandler } from '../../handlers/useGenericRequestHandler'

export const useNativeFormMutation = () => {
  return useGenericRequestHandler({
    route: 'v1/u/nativeForm',
    method: 'POST'
  })
}
